//Add Qty
$(document).ready(function() {
function updateQty(qty) {
  var id = event.target.id;
  // console.log(id)
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+qty+'&id='+id,
    dataType: 'json',
    success: function(cart) {
      theme.miniCart.updateElements();
      theme.miniCart.generateCart();
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
}

  function updateCartQty() {
        var elem = event.target;
      // console.log(elem);
      var qty = parseInt(jQuery(elem).parent('.qtybox').find('.quantity-input').val());
      if(jQuery(elem).hasClass('qtyplus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      jQuery(elem).parent('.qtybox').find('.quantity-input').val(qty);
      // jQuery(elem).parent('.qtybox').find('.quantity-input').trigger('change');
      updateQty(qty)
  }

jQuery(document).ready(function(){
  // close Icon filter sidebar
  jQuery('.filterclose').click(function(){
      jQuery('.js-sidebar').toggleClass('active');
      jQuery('.js-toggle-filter').toggleClass('active');
  });
  // Mobile forget password screen
  jQuery(".pasword").click(function(){
      jQuery("#MainContent #RecoverPasswordForm").removeClass('hide');
      jQuery("#MainContent #customer_login").addClass('hide');     
  });
  // reverse
  jQuery('#RecoverPasswordForm #HideRecoverPasswordLink').click(function(){
      jQuery("#MainContent #RecoverPasswordForm").addClass('hide');
        jQuery("#MainContent #customer_login").removeClass('hide');
  });
  // Replace <li> with <div> inside .benefit-rep .metafield-single_line_text_field-array
  jQuery('.benefit-rep .metafield-single_line_text_field-array li').replaceWith(function() {
    return jQuery('<div>').append(jQuery(this).contents());
  });
  // Replace <ul> with <div> inside .benefit-rep .metafield-single_line_text_field-array
  jQuery('.benefit-rep .metafield-single_line_text_field-array ul').replaceWith(function() {
    return jQuery('<div>').append(jQuery(this).contents());
  });
});

jQuery(document).ready(function() {
  // Replace <ul> with <div> with class "ben-wrapper" inside .benefit-rep
  jQuery('.benefit-rep ul').replaceWith(function() {
    return jQuery('<div>').addClass('ben-wrapper').append(jQuery(this).contents());
  });
});

jQuery('.faqs-rep ul.metafield-single_line_text_field-array li').click(function() {
  if (jQuery(this).hasClass('clicked')) {
        setTimeout(function() { 
            jQuery(this).css("margin-bottom", '30px');
        },500 )
  } else {
      setTimeout(function() { 
    jQuery(this).css("margin-bottom", '0px');
            },500 )
  }
  jQuery(this).toggleClass('clicked');
  jQuery(this).next('li').slideToggle();
});

jQuery(".close").click(function(){
  jQuery(".cardraw").removeClass("active");
});
jQuery(document).ready(function(){jQuery(".swatch :radio").change(function(){var e=jQuery(this).closest(".swatch").attr("data-option-index"),t=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")}),jQuery('.swatch input[type="radio"]:checked').trigger("change"),setTimeout(function(){jQuery(document).on("mouseover",".hero-video",function(){jQuery(this).children("video").get(0).pause()}),jQuery(document).on("mouseleave",".hero-video",function(){jQuery(this).children("video").get(0).play()})},2e3)}),jQuery(document).ready(function(){setTimeout(function(){jQuery(".qv-add-button").click(function(){jQuery(".modal-header .close").click()})},2e3)});


// Cart drawer opan and close
$('.js-toggle-cart').click(function(){
     $('body').addClass('stop-scrolling');
 });
$('.minicart-close,.overlaycart').click(function() {
     $('body').removeClass('stop-scrolling');
 });


// jQuery('.available').click(function(){
//     // Show the "Add to Cart" button
//     jQuery('.product-form__item--submit button.addtocart').show();
//     // Remove the "bold_hidden" class to display the "Sold Out" button
//     jQuery('button#AddToCart-product-template-2').removeClass("bold_hidden");    
//     console.log('class remove krdi hn... bold_hidden'); 

// });


});
